module.exports = __webpack_public_path__ + "img/file-img-png.6c82d326.jpg";